const byPrintInstanceTicketsFilter = function (orderItems) {
    return orderItems.filter((orderItem) => orderItem.item.printTicketPerInstance);
};

module.exports = byPrintInstanceTicketsFilter;
